import type { ReactNode } from "react";
import { Switch } from "./primitives";

/** 꺾쇠가 곧 동작이다 — `page` 는 다른 화면으로, `sheet` 는 이 자리에서 펼친다. */
export type RowAction = "page" | "sheet";

export function SettingGroup({
  title,
  bill = false,
  children,
}: {
  title?: ReactNode;
  bill?: boolean;
  children: ReactNode;
}) {
  return (
    <div className={`setgrp${bill ? " bill" : ""}`}>
      {title ? <h4>{title}</h4> : null}
      {children}
    </div>
  );
}

export interface SettingRowProps {
  label: ReactNode;
  value?: ReactNode;
  action?: RowAction;
  tone?: "default" | "danger" | "total";
  /** 제외된 줄은 지우지 않고 금액에 취소선을 그어 남긴다. */
  struck?: boolean;
  onClick?: () => void;
}

export function SettingRow({ label, value, action, tone = "default", struck = false, onClick }: SettingRowProps) {
  const cls = [
    "setlink",
    tone === "danger" ? "danger" : "",
    tone === "total" ? "total" : "",
    struck ? "off" : "",
    onClick ? "clickable" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const inner = (
    <>
      <span>{label}</span>
      <span className="v mono">
        {value}
        {action ? (
          <span className="chev" aria-hidden="true">
            {action === "page" ? " ›" : " ⌄"}
          </span>
        ) : null}
      </span>
    </>
  );
  if (onClick) {
    return (
      <button type="button" className={cls} onClick={onClick}>
        {inner}
      </button>
    );
  }
  return <span className={cls}>{inner}</span>;
}

export function ToggleRow({
  label,
  on,
  onChange,
}: {
  label: string;
  on: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <div className="toggle">
      <span>{label}</span>
      <Switch on={on} label={label} onChange={onChange} />
    </div>
  );
}
